package ir.site.zero1plus.components.sections

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.functions.clamp
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.layout.SimpleGrid
import com.varabyte.kobweb.silk.components.layout.numColumns
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.toAttrs
import ir.site.zero1plus.components.widgets.MyCard
import ir.site.zero1plus.components.widgets.SectionHeading
import ir.site.zero1plus.model.NavBarMenu
import ir.site.zero1plus.theme.TextPrimaryDark
import ir.site.zero1plus.theme.TextPrimaryLight
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.vw
import org.jetbrains.compose.web.dom.H2
import org.jetbrains.compose.web.dom.H3
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text


val MyCardPStyle = CssStyle {
    base {
        Modifier
            .lineHeight(2.0)
    }
}
val MyHeadingStyle = CssStyle {
    base {
        Modifier
            .paddingBlock(both = 4.px)
            .color(if (colorMode.isDark) TextPrimaryDark else TextPrimaryLight)
    }
}

@Composable
fun AboutMeSection() {
    Box(
        modifier = Modifier.id(NavBarMenu.AboutMe.id)
            .fillMaxWidth()
            .padding(topBottom = 100.px),
        contentAlignment = Alignment.Center
    ) {
        AboutMeItems()
    }
}



@Composable
fun AboutMeItems() {
    Column(
        modifier = Modifier.fillMaxWidth(90.percent)
            .marginBlock(both = 40.px),
        verticalArrangement = Arrangement.Center,
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
       SectionHeading(
           title = "درباره من"
       )
        SimpleGrid(
            numColumns = numColumns(base = 1, sm = 2, lg = 3, xl = 4),
        ) {
            AboutMeCard(
                image = "android.svg",
                title = "اندروید",
                desc = "تیم ما در زمینه توسعه اپلیکیشن های اندروید با استفاده از کاتلین و ابزارهای مدرن مانند Jetpack و Compose فعالیت می کند. تمرکز ما روی ساخت اپ های سریع، پایدار و کاربرپسند است تا بهترین تجربه را برای کاربران فراهم کنیم."
            )
            AboutMeCard(
                imageModifier = Modifier.padding(6.px),
                image = "kotlinicon.svg",
                title = "زبان کاتلین",
                desc = "تیم ما به برنامه نویسی با کاتلین علاقه  دارد و بخش زیادی از زمان خود را صرف یادگیری، به روزرسانی دانش فنی و توسعه اپلیکیشن های کاربردی با این زبان می کند. همیشه به دنبال روش های بهتر هستیم."
            )
            AboutMeCard(
                image = "ktoricon.svg",
                title = "کیتور",
                desc = "تیم ما از فریم ورک Ktor برای توسعه سرویس های سمت سرور استفاده می کند. این فریم ورک با بهره گیری از زبان Kotlin و ساختاری ماژولار، امکان ساخت برنامه های تحت وب سبک، سریع و قابل گسترش را فراهم می کند."
            )
            AboutMeCard(
                image = "kobweb.svg",
                title = "کوب وب",
                desc = "ما با استفاده از فریم ورک Kobweb به توسعه رابط های کاربری مدرن و واکنش گرا برای وب می پردازد. این ترکیب با بهره گیری از قدرت Kotlin، امکان ساخت برنامه های تحت وب سریع، ماژولار و قابل نگهداری را فراهم می کند."
            )
        }
    }
}

@Composable
fun AboutMeCard(
    imageModifier: Modifier = Modifier,
    image: String,
    title: String,
    desc: String = "یک متن ساده باری تست "
) {
    MyCard {
        Column(
            horizontalAlignment = Alignment.CenterHorizontally,
            verticalArrangement = Arrangement.spacedBy(12.px)
        ) {
            Image(
                modifier = imageModifier.size(70.px),
                src = image,
                description = "android"
            )
            H3(
                attrs = MyHeadingStyle.toAttrs()
            ) {
                Text(title)
            }
            P(
                attrs = MyCardPStyle.toAttrs()
            ) {
                Text(desc)
            }
        }
    }
}